import React from 'react';
import {useCallback, useState} from 'react';
import Dropdown from 'react-dropdown';
import {
    initializeMidiEffect,
    midiEffectOptions,
    midiConditionalOptions,
    effectOptions,
    initializeEffect
} from './constants.js';

let _opt = 1;
export default function EffectDropdown({effect, sequencerEngine, track, isMidiEffect, handleChooseEffect, options, placeholder}) {
    let [opt, setOpt] = useState(1);
    const onChange = useCallback((name) => {
        let fx = isMidiEffect ?
            initializeMidiEffect(name, track) :
            initializeEffect(name, sequencerEngine);
        handleChooseEffect(fx);
        setOpt(++_opt);
        setTimeout(() => setOpt(undefined), 50);
    }, [setOpt, effect]);

    let _options = options ? options : isMidiEffect ? midiEffectOptions : effectOptions;
    return (
        <div>
          <Dropdown
            className='effect-dropdown'
            options={_options}
            option={opt === 1 ? undefined : opt}
            value={opt === 1 ? undefined : opt}
            onChange={(o) => onChange(o.value)}
            placeholder={placeholder || "Add FX"}/>
        </div>
    );
}
